import React, { useState } from "react";
import Header from "./../Layout/Header";
import PageTitle from "./../Pages/PageTitle";
import ForexChart from "../component/ForexChart";
import PostTable from "../component/PostTable";
import PostModal from "../component/PostModal";

const Homepage = () => {
  const user = useState(localStorage.getItem("user__sadada(*&(*&("));
  const [selectedPost, setSelectedPost] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState(null);

  const [formState, setFormState] = useState({
    buyCurrency: "USD",
    sellCurrency: "CAD",
  });

  const toggleModal = () => setIsModalOpen((prev) => !prev);
  const handlePostClick = (post, mode) => {
    setSelectedPost(post);
    setModalMode(mode);
    setIsModalOpen(true);
  };

  return (
    <div>
      <Header />
      <PageTitle />
      <div className="homepage mb-80">
        <div className="container">
          <div className="row">
            <div className="card-body pt-0" style={{ height: "650px" }}>
              <ForexChart formState={formState} setFormState={setFormState} />
            </div>
          </div>
          {user[0] && (
            <div className="row">
              <br />
              <PostTable
                onPostClick={handlePostClick}
                tableMode={"buy"}
                formState={formState}
              />
            </div>
          )}
        </div>
      </div>
      <PostModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        post={selectedPost}
        mode={modalMode}
      />
    </div>
  );
};

export default Homepage;
